import React, { useMemo } from 'react';
import { SearchSelectInput } from './Inputs/SearchSelectInput';

interface UfMunicipioSearchFieldsProps {
  estados: { sigla: string; nome: string }[];
  municipios: string[];
  estado: string;
  municipio: string;
  /** O pai limpa o município e recarrega a lista ao trocar a UF. */
  onEstadoChange: (uf: string) => void;
  onMunicipioChange: (municipio: string) => void;
  errors: { estado?: string; municipio?: string };
  loadingEstados?: boolean;
  loadingMunicipios?: boolean;
}

/** Estado (UF) e município com busca digitável + lista (padrão do cadastro de cliente do NexxusOne). */
export const UfMunicipioSearchFields: React.FC<UfMunicipioSearchFieldsProps> = ({
  estados,
  municipios,
  estado,
  municipio,
  onEstadoChange,
  onMunicipioChange,
  errors,
  loadingEstados = false,
  loadingMunicipios = false,
}) => {
  const estadoOptions = useMemo(
    () => estados.map((e) => ({ value: e.sigla, label: e.sigla, hint: e.nome })),
    [estados]
  );
  const municipioOptions = useMemo(
    () => municipios.map((m) => ({ value: m, label: m })),
    [municipios]
  );

  return (
    <>
      <div className="w-full md:w-56 shrink-0">
        <SearchSelectInput
          name="holderState"
          label="Estado"
          value={estado}
          onChange={onEstadoChange}
          options={estadoOptions}
          placeholder="Buscar UF"
          loading={loadingEstados}
          disabled={loadingEstados}
          requiredMark
          errorMessage={errors.estado}
          emptyMessage="Nenhum estado encontrado"
        />
      </div>
      <div className="w-full md:flex-1 min-w-0">
        <SearchSelectInput
          name="holderCity"
          label="Município"
          value={municipio}
          onChange={onMunicipioChange}
          options={municipioOptions}
          placeholder={estado ? 'Buscar município' : 'Selecione o estado'}
          loading={loadingMunicipios}
          disabled={!estado || loadingMunicipios || loadingEstados}
          requiredMark
          errorMessage={errors.municipio}
          emptyMessage="Nenhum município encontrado"
        />
      </div>
    </>
  );
};
